import { Injectable, inject, OnDestroy } from '@angular/core';
import { Subject, Subscription, filter } from 'rxjs';
import { FikoYTService } from '../../../../service/fikoyt.service';

// ─── EVENT TİPLERİ ──────────────────────────────────────────────────────────

export interface ICihazAktivasyonOlay {
  tip: 'aktivasyon_yeni_kayit' | 'aktivasyon_durum_degisti';
  cihaz_kimlik: string;
  cihaz_id?: string;
  firma_id?: string;
  cihaz_adi?: string;
  durum?: string;
  firma_adi?: string;
  uygulama_modu?: string;
  konum?: string;
  aktivasyon_kodu?: string;
}

// ─── SERVİS ──────────────────────────────────────────────────────────────────

@Injectable({ providedIn: 'root' })
export class CihazAktivasyonSocketService implements OnDestroy {
  private fikoyt = inject(FikoYTService);

  private _olaylar$ = new Subject<ICihazAktivasyonOlay>();
  private _sub: Subscription | null = null;
  private _reconnectSub: Subscription | null = null;

  /** Tüm aktivasyon olayları stream'i */
  readonly olaylar$ = this._olaylar$.asObservable();

  /** Belirli bir cihaz kimliğine ait olayları filtrele */
  cihazOlaylari$(cihazKimlik: string) {
    return this.olaylar$.pipe(
      filter(o => o.cihaz_kimlik === cihazKimlik),
    );
  }

  /** Belirli bir firmaya ait olayları filtrele */
  firmaOlaylari$(firmaId: string) {
    return this.olaylar$.pipe(
      filter(o => o.firma_id === firmaId),
    );
  }

  /** Socket.IO dinlemeyi başlat (bir kez çağrılır) */
  dinlemeBasla() {
    if (this._sub) return;

    const socket = this.fikoyt.io;
    if (!socket) {
      console.warn('[AktivasyonSocket] Socket.IO bulunamadi, 2sn sonra tekrar denenecek');
      setTimeout(() => {
        this._sub = null;
        this.dinlemeBasla();
      }, 2000);
      return;
    }

    console.log('[AktivasyonSocket] Dinleme baslatiliyor...');

    this._sub = socket.fromEvent('FikoYT.sistem.io.cihaz.guncellendi')
      .subscribe((data: any) => {
        // ngx-socket-io bazen veriyi array olarak sarar
        const payload = Array.isArray(data) ? data[0] : data;
        if (!payload || typeof payload !== 'object') return;

        console.log('[AktivasyonSocket] Event geldi:', payload?.tip, payload?.durum, payload?.cihaz_kimlik);

        // Sadece aktivasyon event'lerini yakala
        if (payload?.tip?.startsWith('aktivasyon_')) {
          console.log('[AktivasyonSocket] Aktivasyon olayi tespit edildi, yayinlaniyor');
          this._olaylar$.next(payload as ICihazAktivasyonOlay);
        }
      });

    // Reconnect sonrası tekrar abone ol
    this._reconnectSub = socket.fromEvent('connect').subscribe(() => {
      console.log('[AktivasyonSocket] Socket.IO yeniden baglandi');
    });
  }

  /** Aktivasyon olayı bildir (Socket.IO üzerinden broadcast) */
  bildir(olay: ICihazAktivasyonOlay) {
    const socket = this.fikoyt.io;
    if (!socket) {
      console.warn('[AktivasyonSocket] bildir: Socket.IO bulunamadi');
      return;
    }

    const veri = {
      ...olay,
      cihaz_kimlik: olay.cihaz_kimlik,
      zaman: new Date().toISOString(),
    };

    console.log('[AktivasyonSocket] Event yayinlaniyor:', veri.tip, veri.durum, veri.cihaz_kimlik);

    // Go backend FikoYT.sistem.io.cihaz.guncellendi handler'ı
    // bu event'i tüm diğer client'lara broadcast eder
    socket.emit('FikoYT.sistem.io.cihaz.guncellendi', veri);
  }

  ngOnDestroy() {
    this._sub?.unsubscribe();
    this._sub = null;
    this._reconnectSub?.unsubscribe();
    this._reconnectSub = null;
  }
}
